import reperesEconomiquesApi from '@/api/reperes-economiques.api'

const getDefaultState = () => {
  return {
    configurationGraineActive: {},
    reperesEconomiquesByGraine: {},
    reperesEconomiques: []
  }
}

const module = {
  namespaced: true,

  state: getDefaultState(),

  getters: {
    configurationGraineActive (state) {
      return state.configurationGraineActive
    },
    reperesEconomiquesByGraine (state) {
      return state.reperesEconomiquesByGraine
    },
    reperesEconomiques (state) {
      return state.reperesEconomiques
    }
  },
  mutations: {
    SET_CONFIGURATION (state, configurationGraineActive) {
      state.configurationGraineActive = configurationGraineActive
    },
    SET_REPERES_ECONOMIQUES (state, reperesEconomiques) {
      state.reperesEconomiques = reperesEconomiques
    },
    SET_REPERES_ECONOMIQUES_BY_GRAINE (state, reperesEconomiquesByGraine) {
      state.reperesEconomiquesByGraine = reperesEconomiquesByGraine
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    getConfigurationParGraine ({ commit }, codeGraineRs3) {
      return reperesEconomiquesApi.getConfigurationGraine(codeGraineRs3)
        .then(configuration => {
          commit('SET_CONFIGURATION', configuration)
        })
    },
    getReperesEconomiques ({ commit }) {
      return reperesEconomiquesApi.getReperesEconomiques()
        .then(reperesEconomiques => {
          commit('SET_REPERES_ECONOMIQUES', reperesEconomiques)
        })
    },
    updateRepereEconomiqueItem ({ dispatch }, item) {
      return reperesEconomiquesApi.updateRepereEconomiqueItem(item)
        .then(() => dispatch('getReperesEconomiques'))
    },
    getReperesEconomiqueByGraine ({ commit, rootGetters }, codeGraineRs3) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return reperesEconomiquesApi.getReperesEconomiquesByGraine(username, codeGraineRs3)
        .then(reperesEconomiques => {
          commit('SET_REPERES_ECONOMIQUES_BY_GRAINE', reperesEconomiques)
          return reperesEconomiques
        })
    },
    saveReperesEconomiques ({ dispatch, rootGetters }, reperesEconomiques) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const request = reperesEconomiques.id ?
        reperesEconomiquesApi.update(username, reperesEconomiques) :
        reperesEconomiquesApi.create(username, reperesEconomiques)

      return request.then(() => {
        dispatch('getReperesEconomiqueByGraine', reperesEconomiques.codeGraineRs3)
      })
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
